import type {AxiosRequestConfig} from 'axios';

import http from '@/shared/api/http';

export const AuthApi = {
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
   get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
      return http.get(url, config) as unknown as Promise<T>;
   },

   // eslint-disable-next-line @typescript-eslint/no-explicit-any
   request<T = any>(config: AxiosRequestConfig): Promise<T> {
      return http.request(config) as unknown as Promise<T>;
   },

   /**
    * Revoke the current session.
    *
    * Answers with `sso_logout_url` when the person signed in through a connection that ends the
    * provider's session too. The token is revoked either way, so a caller that ignores the URL
    * has still signed them out of this platform.
    *
    * @returns The sign-out result, carrying the provider URL to visit next or null.
    */
   logout(): Promise<{message: string; sso_logout_url: string | null}> {
      return http.post('/auth/logout', null);
   },

   setAuthHeader(accessToken: string): void {
      http.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
   },

   clearAuthHeader(): void {
      delete http.defaults.headers.common['Authorization'];
   },
};
